<template>
    <b-modal :title="this.$route.name" hide-footer size="md" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="UpdateCustomerType">
            <div>
                <div  class="form-group row">
                    <label for="name" class="col-sm-12 col-form-label"> Name</label>
                    <div class="col-sm-12">
                        <input name="name" v-validate="'required'" v-model="editCustomerTypeForm.name" class="form-control"  >
                        <!--                        <p  v-show="errors.has('bn_name')" style="color:red">* {{ errors.first('bn_name') }}</p>-->
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <input v-if="!addLoader" type="submit" value="Update" class="btn btn-primary pull-right"/>
                        <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Submitting...
                        </button>
                        <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    import axios from 'axios'
    export default {
        data(){
            return{
                largeModal:false,
                addLoader: false,
                index:'',
                editCustomerTypeForm:{
                    name:'',
                    id:''
                }
            }
        },

        computed:{
            ...mapGetters(['modal'])
        },
        mounted(){
        },
        methods:{
            openModal(customer,index){
                this.largeModal = true
                this.index = index
                this.editCustomerTypeForm.name = customer.name
                this.editCustomerTypeForm.id = customer.id
            },
            close(){
                this.largeModal = false
            },
            UpdateCustomerType(){
                var customerEditForm = this.editCustomerTypeForm
                var index = this.index
                this.$store.dispatch('UPDATE_CUSTOMER_TYPE',{customerEditForm,index})
                    .then(v=>{
                        this.largeModal = this.state
                    })
            }
        }

    }
</script>
<style>

</style>